const IconDone = ({ fillColor = "inherit", size = "24px" }) => {
  return (
    <svg height={size} width={size} viewBox="0 -960 960 960" fill={fillColor}>
      <path d="M378-246 154-470l43-43 181 181 384-384 43 43-427 427Z"/>
    </svg>
  );
};

export default IconDone;
